import { render, staticRenderFns } from "./DetailTableContact.vue?vue&type=template&id=1cf81796&"
import script from "./DetailTableContact.vue?vue&type=script&lang=js&"
export * from "./DetailTableContact.vue?vue&type=script&lang=js&"
import style0 from "./DetailTableContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports